// Real acoustic grand piano: the free Salamander Grand Piano (Yamaha C5)
// recordings, loaded directly with Tone.Sampler from the Tone.js audio host.
// Dry (no reverb) for a clean, natural sound; short release for snappy notes.
import * as Tone from "tone";

let sampler = null;
let started = false;

const SALAMANDER_BASE = "https://tonejs.github.io/audio/salamander/";

// Sample every 3 semitones (C, D#, F#, A) across the range; the Sampler
// pitch-shifts the nearest sample for notes in between. "s" = sharp.
const SAMPLE_URLS = {
  C1: "C1.mp3", "D#1": "Ds1.mp3", "F#1": "Fs1.mp3", A1: "A1.mp3",
  C2: "C2.mp3", "D#2": "Ds2.mp3", "F#2": "Fs2.mp3", A2: "A2.mp3",
  C3: "C3.mp3", "D#3": "Ds3.mp3", "F#3": "Fs3.mp3", A3: "A3.mp3",
  C4: "C4.mp3", "D#4": "Ds4.mp3", "F#4": "Fs4.mp3", A4: "A4.mp3",
  C5: "C5.mp3", "D#5": "Ds5.mp3", "F#5": "Fs5.mp3", A5: "A5.mp3",
  C6: "C6.mp3", "D#6": "Ds6.mp3", "F#6": "Fs6.mp3", A6: "A6.mp3",
};

const midiToNote = (m) => Tone.Frequency(m, "midi").toNote();

const initEngine = () => {
  if (sampler) return;
  sampler = new Tone.Sampler({
    urls: SAMPLE_URLS,
    baseUrl: SALAMANDER_BASE,
    release: 0.5, // short, natural release
    volume: -4,
  }).toDestination();
};

// Preload the sampler/samples so the first note plays instantly.
export const preloadPiano = () => {
  initEngine();
};

// The Web Audio context can only start after a user gesture.
const ensureStarted = async () => {
  initEngine();
  if (!started) {
    try {
      await Tone.start();
      started = true;
    } catch (e) {
      /* will retry on next gesture */
    }
  }
};

// Slightly shorter, snappier notes than before.
export const playNote = (midi, duration = 0.5) => {
  ensureStarted().then(() => {
    if (!sampler || !sampler.loaded) return;
    sampler.triggerAttackRelease(midiToNote(midi), duration);
  });
};

export const playChord = (midis, duration = 0.85) => {
  ensureStarted().then(() => {
    if (!sampler || !sampler.loaded) return;
    sampler.triggerAttackRelease(midis.map(midiToNote), duration);
  });
};

export const playScale = (midis, onEach) => {
  ensureStarted();
  const step = 0.42;
  midis.forEach((m, i) => {
    setTimeout(() => {
      playNote(m, 0.38);
      if (onEach) onEach(m, i);
    }, i * step * 1000);
  });
  return midis.length * step * 1000;
};
